import { generalManual } from './modules/general';
import { gestionManual } from './modules/gestion';
import { comprasManual } from './modules/compras';
import { ventasManual } from './modules/ventas';
import { almacenesManual } from './modules/almacenes';
import { produccionManual } from './modules/produccion';
import { produccionConcesionariaManual } from './modules/produccionConcesionaria';
import { restaurantesManual } from './modules/restaurantes';
import { maquinariaManual } from './modules/maquinaria';
import { activosManual } from './modules/activos';
import { auditoriaManual } from './modules/auditoria';
import { administracionManual } from './modules/administracion';
import { contabilidadManual } from './modules/contabilidad';
import { adminManual } from './modules/admin';

/** Orden del índice del manual (coincide con menú lateral aproximado). */
export const allManualModules = [
  generalManual,
  gestionManual,
  comprasManual,
  ventasManual,
  almacenesManual,
  maquinariaManual,
  activosManual,
  produccionManual,
  produccionConcesionariaManual,
  restaurantesManual,
  auditoriaManual,
  administracionManual,
  contabilidadManual,
  adminManual,
];

export const MANUAL_VERSION = '2026-10-26-manual-sin-capturas';

/** Mostrar recuadros «Insertar captura» en /manual. Activar cuando haya imágenes reales. */
export const MANUAL_SHOW_SCREENSHOT_PLACEHOLDERS = false;
